import { DetectorEditor } from './Humanizer/detector-editor'

const DetectorPage = () => {
	return (
		<div className="flex flex-col gap-5 mt-12">
			<div className="flex flex-col z-10">
				<div className="text-3xl font-bold text-center">AI Detector</div>
				<div className="text-center text-gray-700">Scan for AI using 6 different detectors.</div>
				<div className="text-center text-gray-700">
					Powered by{' '}
					<a href="https://mask.ai" target="_blank" rel="noopener noreferrer" className="underline text-black">
						Mask AI
					</a>{' '}
				</div>
			</div>
			<div className="z-10 max-w-6xl mx-auto w-full pb-96 md:pb-24">
				<DetectorEditor />
			</div>
			<div className="w-screen h-screen fixed bg-gradient-to-b from-white to-[#3b82f6] top-0 opacity-15" />
		</div>
	)
}

export default DetectorPage
